module.exports = __webpack_public_path__ + "media/images/flags/64/Azerbaijan-398ef055c33ac6355bc67abd49d61c89.png";